// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin › Settings › Roles (default roles + service-provider roles and permissions). */

.roles-page {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-6);
  min-width: 0;
}

.roles-page__section {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  min-width: 0;
}

.roles-page__default {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
}

.roles-page__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.roles-page__heading {
  margin: 0;
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
}

.roles-page .page-toolbar {
  margin-bottom: 0;
}

.roles-page__perms.ant-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2) var(--ds-space-4);
}

.roles-page__perms .ant-checkbox-wrapper {
  min-height: 40px;
  align-items: center;
  margin-inline-end: 0;
}

.roles-page__save {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--ds-space-4);
}

@media (max-width: 767.98px) {
  .roles-page__save .ant-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/rolesAndPermissions/RolesManagement.css"],"names":[],"mappings":"AAAA,uFAAuF;;AAEvF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* Admin › Settings › Roles (default roles + service-provider roles and permissions). */\n\n.roles-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-6);\n  min-width: 0;\n}\n\n.roles-page__section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n  min-width: 0;\n}\n\n.roles-page__default {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n}\n\n.roles-page__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.roles-page__heading {\n  margin: 0;\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.roles-page .page-toolbar {\n  margin-bottom: 0;\n}\n\n.roles-page__perms.ant-checkbox-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2) var(--ds-space-4);\n}\n\n.roles-page__perms .ant-checkbox-wrapper {\n  min-height: 40px;\n  align-items: center;\n  margin-inline-end: 0;\n}\n\n.roles-page__save {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: var(--ds-space-4);\n}\n\n@media (max-width: 767.98px) {\n  .roles-page__save .ant-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
